import { useFlag } from '@/flags';

/**
 * Accounts without a Source subscription. The flag is only present (and true)
 * for free-tier accounts, so its absence means the account is subscribed.
 */
export function useSourceFreemium(): boolean {
  return useFlag('source-freemium');
}
